<template>
  <div class="header-wrapper" :class="[{ fixedToTop }]">
    <div class="nav-wrapper header-default">
      <!-- 导航菜单 - 桌面端完整显示 -->
      <div v-if="!isMobile" class="nav desktop-nav">
        <div v-if="!isMobile && !isTablet" class="header-left"
          style="font-size: 24px;font-weight: 700;color: #000;cursor: pointer;" @click="goWebHandle">
          <img src="@/assets/logo.png" alt="" style="width: 60px; height: 60px;border-radius: 50%;" />
          <div class="header-title" style="width: 80px;">专加瓦</div>
        </div>

        <ul class="menu-list">
          <li v-for="item in menuList" :key="item.path" class="menu-item">
            <!-- 一级菜单（无子菜单） -->
            <router-link 
              v-if="!item.children || item.children.length === 0" 
              class="router" 
              :to="item.path"
              :class="{ 'router-link-active': isActiveRoute(item.path) }"
            >
              <el-badge v-if="item.meta?.badge" :value="item.meta.badge" class="item">
                {{ item.meta?.title || item.name }}
              </el-badge>
              <span v-else>{{ item.meta?.title || item.name }}</span>
            </router-link>
            
            <!-- 一级菜单（有子菜单） -->
            <div v-else class="menu-with-children">
              <router-link 
                class="router" 
                :to="item.redirect || item.children[0]?.path"
                :class="{ 'router-link-active': isActiveRoute(item.path) }"
              >
                <el-badge v-if="item.meta?.badge" :value="item.meta.badge" class="item">
                  {{ item.meta?.title || item.name }}
                </el-badge>
                <span v-else>{{ item.meta?.title || item.name }}</span>
              </router-link>
            </div>
          </li>
        </ul>
      </div>

      <!-- 右侧用户信息区域 -->
      <div class="rightInfo">
        <div class="createAccount" v-if="!hasToken">
          <el-button type="primary" round @click="loginHandle">登录</el-button>
        </div>

        <div v-else class="createAccount">
          <el-popover placement="bottom" width="400" trigger="hover" style="z-index: 1;" @after-enter="userClickHandle">
            <div slot="reference" style="display: flex;align-items: center;" class="avatar-wrapper">
              <img src="@/assets/avatar1.png" alt=""
                style="width: 45px; height: 45px;border-radius: 50%;box-shadow: -1px 2px 10px #DBE0F2;margin-right: 5px;" />
              <div v-if="userInfo2.tel">{{ userInfo2.tel }}</div>
            </div>

            <div class="userInfo">
              <div class="userInfo_avatar">
                <div>
                  <img src="@/assets/avatar1.png" alt=""
                    style="width: 45px; height: 45px;border-radius: 50%;box-shadow: -1px 2px 10px #DBE0F2;" />
                </div>
                <div style="font-size: 18px;font-weight: 600;margin-left: 15px;color: #000;">{{ userInfo2.tel }}</div>
              </div>

              <div class="memberInformation">
                <div v-if="!isVip" style="font-size: 20px;color: #c59a54;font-weight: 600;text-align: center;">您现在还不是会员
                </div>
                <div v-if="isVip" style="font-size: 20px;color: #c59a54;font-weight: 600;text-align: center;">
                  <div>{{ vipNewInfo.vipDisplayName }}</div>
                  <div>有效期：{{ expirationDate }}到期</div>
                </div>
                <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 10px;">
                  <div class="pointsBalance">
                    <div>积分余额</div>
                    <div style="font-size: 25px;font-weight: 600;color: #c59a54;">{{ remainingPoints }}</div>
                  </div>
                  <div class="pointsBalance">
                    <div>月积分使用量</div>
                    <div style="font-size: 25px;font-weight: 600;">{{ pointMonth || 0 }}</div>
                  </div>
                </div>
              </div>

              <div class="modelList">
                <div v-for="(item, index) in filteredFunctionalModule" :key="index" class="modelItem"
                  @click="gotoPage(item)">
                  <div style="display: flex;align-items: center;">
                    <div><img :src="item.img" style="width: 20px;height: 20px;" /></div>
                    <div style="margin-left: 8px;">{{ item.title }}</div>
                  </div>
                </div>
              </div>

            </div>
          </el-popover>
        </div>
      </div>

      <!-- 移动端菜单按钮 -->
      <div class="mobile-menu-btn" v-if="isMobile" @click="toggleMobileMenu">
        <i class="el-icon-menu"></i>
      </div>
    </div>

    <!-- 移动端菜单 -->
    <div class="mobile-menu" v-if="isMobile && isMobileMenuVisible">
      <div class="menu-content">
        <div v-for="(item, index) in mobileMenuItems" :key="index" @click="gotoPageFromMobile(item)">
          {{ item.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppFunctions from "@/utils/AppFunctions";
import { purchasePoints, accountSettings, website, myOrder, logOut, membership } from '@/assets/imageExprot.js'
import http from '@/utils/http';
import { formatTime } from '@/utils/fiflter';
// 关键修改1：导入 defaultLayoutPages 替代原有的 routes
import { defaultLayoutPages } from '@/router/menuRoutes';

export default {
  name: "Header",
  components: {},
  props: {
    fixedToTop: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      AppFunctions,
      functionalModule: [
        {
          img: purchasePoints,
          title: '购买积分',
          url: '/purchasePoints',
          isShow: true,
        },
        {
          img: membership,
          title: '购买会员',
          url: '/purchaseMember',
          isShow: true,
        },
        {
          img: myOrder,
          title: '我的订单',
          url: '/order',
          isShow: true,
        },
        {
          img: accountSettings,
          title: '子账号管理',
          url: '/childUser',
          isShow: true,
        },
        {
          img: accountSettings,
          title: '合伙人管理',
          url: '/recommendationOfficer',
          isShow: false,
        },
        {
          img: website,
          title: '访问官网',
          url: '/website/index', // 关键修改2：适配官网路由的路由前缀 /website
          isShow: true,
        },
        {
          img: logOut,
          title: '退出登录',
          url: '/login', // 关键修改3：适配空白布局的路由前缀 /blank
          isShow: true,
        },
      ],
      userNewInfo: {},
      vipNewInfo: {},
      isVip: false,
      userInfo: {},
      featureDetailsJson: {},
      scrollHandler: null,
      isMobile: false,
      isTablet: false,
      isMobileMenuVisible: false,
      isSticky: false,
      isOpenRecommend: false,
      expirationDate: null,
    };
  },

  computed: {
    userInfo2() {
      let data = localStorage.getItem('userInfo2')
      return JSON.parse(data) || {}
    },
    hasToken() {
      return localStorage.getItem('token')
    },
    remainingPoints() {
      return this.$store.getters.getPoint || JSON.parse(localStorage.getItem('remainingPoints'))
    },
    pointMonth() {
      return this.$store.getters.usePoint || JSON.parse(localStorage.getItem('pointMonth'))
    },
    filteredFunctionalModule() {
      return this.functionalModule.filter(item => item.isShow === true);
    },
    // 从路由配置生成菜单列表
    menuList() {
      // 关键修改 4：使用 defaultLayoutPages 替代 routes，并增加空值保护
      const menuRoutes = defaultLayoutPages || [];
      // 过滤出需要在菜单中显示的路由
      return menuRoutes.filter(route => {
        // 排除隐藏的路由
        if (route.meta?.hiddenInMenu) return false;
        // 排除通配符路由
        if (route.path === '*') return false;
        // 排除重定向路由（没有 component 的）
        if (!route.component && !route.redirect) return false;
        // 排除 isShow 为 false 的路由
        if (route.meta?.isShow === false) return false;
        return true;
      }).map(route => ({
        ...route,
        // 确保子路由也过滤掉隐藏的，增加空值保护
        children: (route.children || []).filter(child => !child.meta?.hiddenInMenu && child.meta?.isShow !== false)
      }));
    },
    // 移动端菜单项
    mobileMenuItems() {
      const items = [];
      (this.menuList || []).forEach(route => { // 关键修改5：增加空值保护
        items.push({
          title: route.meta?.title || route.name,
          path: route.path
        });
        // 如果有子菜单，也加入，增加空值保护
        if (route.children && route.children.length > 0) {
          route.children.forEach(child => {
            items.push({
              title: `— ${child.meta?.title || child.name}`,
              path: child.path.startsWith('/') ? child.path : `${route.path}/${child.path}`
            });
          });
        }
      });
      return items;
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.detectDeviceType);
  },
  
  mounted() {
    const shouldSkip =
      this.$route.meta.layout === 'blank' ||
      this.$route.path === '/' ||
      this.$route.path === '/login'; // 关键修改6：适配空白布局的登录页路径

    if (!shouldSkip) {
      this.getUserInfo();
    }

    this.detectDeviceType();
    window.addEventListener('resize', this.detectDeviceType);
  },

  methods: {
    // 判断路由是否激活（包含子路由）
    isActiveRoute(path) {
      return this.$route.path.startsWith(path);
    },

    userClickHandle() {
      this.getRecommendIsOpen()
    },

    getRecommendIsOpen() {
      http.get('/recommend/isOpen').then(res => {
        if (res.code === 200) {
          const recommendIsOpen = res.data;
          this.functionalModule.forEach((item, index) => {
            const isShow = item.title === '推荐官管理' ? recommendIsOpen : true;
            this.$set(this.functionalModule[index], 'isShow', isShow);
          });
        }
      })
    },

    goWebHandle() {
      this.$router.push('/website/index') 
    },

    getUserInfo() {
      http.get('/customerusers/user/owner').then((res) => {
        if (res.code === 200) {
          let userData = res.data
          if (userData.vipInfo != null) {
            userData.vipInfo.vipTemplateInfo = JSON.parse(userData.vipInfo.vipTemplateInfo);
            this.userInfo = userData
            this.isVip = Object.keys(this.userInfo.vipInfo).length > 0
            this.vipNewInfo = this.userInfo.vipInfo.vipTemplateInfo
            this.expirationDate = formatTime(userData.vipInfo.expirationDate, 'YYYY年MM月DD日')
          }
          localStorage.setItem("userInfo", JSON.stringify(userData));
          this.$store.commit('setUserInfo', userData);
        }
      });
    },

    loginHandle() {
      this.$router.push({ path: "/login" });
    },

    gotoPage(item) {
      if (item.url === '/login') { 
        this.$store.commit('clearToken');
        this.$router.push('/login');
      } else {
        this.$router.push(item.url);
      }
    },

    gotoPageFromMobile(item) {
      this.$router.push(item.path);
      this.isMobileMenuVisible = false;
    },

    detectDeviceType() {
      this.isMobile = window.innerWidth < 768;
      this.isTablet = window.innerWidth >= 768 && window.innerWidth <= 1199;
      if (this.isMobile) {
        this.isMobileMenuVisible = false;
      }
    },

    toggleMobileMenu() {
      this.isMobileMenuVisible = !this.isMobileMenuVisible;
    }
  }
};
</script>

<style scoped lang="scss">
/* 基础样式 */
.header-wrapper {
  width: 100%;
  background-color: #fff;
  height: 90px !important;
}

.fixedToTop {
  position: fixed;
  top: 0;
  left: 0;
  height: 90px;
  width: 100%;
}

.nav-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 50px;
  box-sizing: border-box;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-left img {
  width: 50px;
  height: 50px;
  margin-right: 10px;
}

/* 桌面端导航样式 */
.desktop-nav {
  flex: 1;
  max-width: 1200px;
  display: flex;
  justify-content: center;
  overflow-x: auto;
  height: 60px;
  overflow-y: hidden;
  align-items: center;

  ::v-deep(.el-badge__content.is-fixed) {
    top: -5px;
  }
}

.desktop-nav::-webkit-scrollbar {
  width: 3px;
  height: 2px;
}

.desktop-nav::-webkit-scrollbar-track {
  background: rgba(240, 240, 240, 0.3);
  border-radius: 3px;
}

.desktop-nav::-webkit-scrollbar-thumb {
  background: rgba(163, 163, 163, 0.6);
  border-radius: 3px;
  transition: background 0.3s ease;
}

.desktop-nav::-webkit-scrollbar-thumb:hover {
  background: rgba(120, 120, 120, 0.8);
}

.menu-list {
  display: flex;
  justify-content: space-between;
  list-style: none;
  flex-wrap: nowrap;
  min-width: 0;
  margin: 0;
  padding: 0;
  margin-left: 50px;
}

.menu-item {
  white-space: nowrap;
  margin-right: 20px;
}

.menu-item:last-child {
  margin-right: 40px;
}

.router {
  color: #1A1a1a;
  text-decoration: none;
  padding: 5px 10px;
  border-radius: 4px;
  transition: all 0.3s;
  font-size: 1.5rem;
}

.router.router-link-active {
  color: #409EFF;
  font-weight: 700;
}

.router:hover {
  color: #409EFF;
}

.menu-with-children {
  position: relative;
}

/* 右侧用户信息样式 */
.rightInfo {
  display: flex;
  align-items: center;
}

.userInfo {
  margin-top: 10px;
  margin-bottom: 10px;
  box-sizing: border-box;

  .userInfo_avatar {
    display: flex;
    align-items: center;
  }

  .memberInformation {
    margin-top: 30px;
    margin-left: 20px;
    margin-right: 20px;
    display: flex;
    flex-direction: column;

    .pointsBalance {
      font-size: 15px;
      font-weight: 600;
      color: #000;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }

  .modelList {
    margin-top: 30px;
    cursor: pointer;

    .modelItem {
      font-size: 17px;
      font-weight: 600;
      color: #000;
      padding: 10px;
      box-sizing: border-box;
    }

    .modelItem:hover {
      background-color: #dfe9f7b0;
      border-radius: 10px;
    }
  }
}

.featureJson {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  flex-direction: column;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
  color: #000;
}

.createAccount {
  display: flex;
  align-items: center;
  cursor: pointer;
}

/* 移动端样式 */
.mobile-menu-btn {
  font-size: 24px;
  cursor: pointer;
  display: none;
}

.mobile-menu {
  position: fixed;
  top: 0;
  left: -100px;
  height: 100vh;
  background-color: #fff;
  color: #000;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  padding: 15px 0;
  z-index: 999999;
  transition: transform 0.3s ease-in-out;
  transform: translateX(100%);

  &.visible {
    transform: translateX(0);
  }
}

.menu-content {
  padding: 20px;
}

.menu-content>div {
  padding: 12px 0;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  font-size: 16px;
}

.menu-content>div:last-child {
  border-bottom: none;
}

.menu-content>div:hover {
  background-color: #f5f7fa;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .nav-wrapper {
    padding: 15px 20px;
    justify-content: flex-start;
  }

  .header-left {
    font-size: 24px;
  }

  .header-left img {
    width: 40px;
    height: 40px;
  }

  .mobile-menu-btn {
    display: block;
  }

  .rightInfo .createAccount {
    margin-left: 15px;
  }
}

/* 媒体查询 - 小屏幕桌面 */
@media (max-width: 1024px) {
  .router {
    gap: 1.5rem;
    margin: 0 1rem;
    font-size: 1.3rem;
  }

  .menu-item {
    font-size: 1rem;
    margin-right: 10px !important;
  }

  .header-title {
    display: none;
  }
}

.avatar-wrapper {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-radius: 50%;
  margin-top: 5px;
}

.avatar-wrapper:hover {
  transform: translateY(-4px);
}
</style>